/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import {
  ActionIcon,
  Menu,
  Text,
  rem,
  useMantineTheme,
  type DefaultMantineColor,
  type StyleProp,
} from '@mantine/core';
import { RiMore2Line } from '@remixicon/react';

import { TextVariants } from '@fai/ui/components/typography/variants';

export function EllipsisMenu({ children }: { children: React.ReactNode }) {
  const theme = useMantineTheme();

  return (
    <Menu position="bottom-end">
      <Menu.Target>
        <ActionIcon size={rem(32)} variant="outline">
          <RiMore2Line color={theme.pf.color.fg.neutral.default} size={18} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown miw={rem(160)} style={{ boxShadow: theme.pf.shadow['shadow-md'] }}>
        {children}
      </Menu.Dropdown>
    </Menu>
  );
}

export const EllipsisMenuItem = ({
  onClick,
  children,
  disabled,
  c,
}: {
  onClick: VoidFunction;
  children: string;
  c?: StyleProp<DefaultMantineColor>;
  disabled?: boolean;
}) => {
  const theme = useMantineTheme();

  return (
    <Menu.Item
      bg={disabled ? theme.pf.color.bg.neutral.subtle.base : undefined}
      disabled={disabled}
      onClick={onClick}
    >
      <Text c={c ?? theme.pf.color.fg.neutral.strong} variant={TextVariants.BodyMd}>
        {children}
      </Text>
    </Menu.Item>
  );
};
